export default class Controller {

    static get $inject() {
        return [
            '$state',
            'AccountService',
            'LanguageService',
            'gettext',
            'toaster',
        ];
    }

    constructor($state,
                AccountService,
                LanguageService,
                gettext,
                toaster,) {

        this._$state = $state;
        this.gettext = gettext;
        this.LanguageService = LanguageService;
        this._AccountService = AccountService;
        this.toaster = toaster;
        this.placeholdersText = [gettext('Old password'), gettext('New password'), gettext('Retype password')]
        this.item = {new_password1: '', new_password2: '', old_password: ''}
    }

    popSuccess() {
        this.toaster.pop("success", "Success", "Saved")
    }

    showGeneralErrMsg() {
        this.toaster.pop("error", "Error", 'An error has occurred');
    }

    submit() {
        this._AccountService.changePassword(this.item).then(() => {
            this.popSuccess();
            this._$state.go('main.panels');
        }).catch(err => {
            let errText = _.values(err.data);

            if (!_.isEmpty(errText)) {
                this.toaster.pop("error", "Error", errText.join(' '));
            }
            else {
                this.showGeneralErrMsg();
            }
        });
    }

    getTranslatableText(text) {

        return this.LanguageService.getTranslatableText(text)

    }


}


















/** WEBPACK FOOTER **
 ** ./src/main/account/changePassword/controller.js
 **/